<div class="sec-title">
  <h1>Liste de propositions</h1>
</div>
<hr>

<ul class="list-group">
  <li class="list-group-item" *ngFor="let proposition of propositionList">
    
    <div class="card">
      <div class="card-body">
        <h5 class="card-title mb-5">{{proposition.proposition_name}}</h5>
        <p class="card-text">ID: {{proposition.proposition_id}}</p>
        <p class="card-text">Soumission: {{proposition.submission_id}}</p>
        <p class="card-text">Template: {{proposition.template_id}}</p>
        <p class="card-text">Date: {{proposition.proposition_date}}</p>
        <p class="card-text">Crée: {{proposition.created}}</p>

        <ckeditor data="{{proposition.proposition}}"></ckeditor>

      </div>
    </div>

  </li>
</ul>